import { call } from 'redux-saga/effects'
import startUp from '../startUp'

export default function* startUpProcess() {
  try {
    yield call(startUp)
  } catch (e) {
    // pushToSentry(e);
  }
}